import React, { FC } from 'react';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, IconButton, Typography } from '@mui/material';
import {
  FieldPathByValue,
  useFieldArray,
  useFormContext,
} from 'react-hook-form';
import {
  AddButton,
  ConditionalDivider,
  GroupWrapper,
  InnerContainer,
  RuleBg,
  TitleContainer,
} from 'src/components/Forms/CustomFormulaForm/Filters/FilterCollapse/styled';

import { DashboardForm, FilterWithValue } from '../../types';

import { Rule } from './Rule';

interface RulesGroupProp {
  groupName: string;
  filter: FilterWithValue;
  formulaItemIndex: number;
  filterItemIndex: number;
  onDeleteGroup: () => void;
}

export const RulesGroup: FC<RulesGroupProp> = ({
  groupName,
  filter,
  formulaItemIndex,
  filterItemIndex,
  onDeleteGroup,
}) => {
  const { control } = useFormContext<DashboardForm>();

  const filtersGroupPath: FieldPathByValue<
    DashboardForm,
    { operator: string; values: string[] }[]
  > = `filters.${formulaItemIndex}.values.${filterItemIndex}.filtersGroup`;

  const { fields, append, remove } = useFieldArray({
    control,
    name: filtersGroupPath,
  });

  const handleAddRule = () =>
    append({ operator: filter.operators[0].key, values: [] });

  return (
    <GroupWrapper>
      <TitleContainer>
        <Typography>{groupName}</Typography>
        <IconButton onClick={onDeleteGroup}>
          <DeleteIcon />
        </IconButton>
      </TitleContainer>
      <InnerContainer>
        {fields.map(({ id }, index) => (
          <Box key={id}>
            <RuleBg>
              <Rule
                ruleName={`Rule ${index + 1}`}
                filterPath={`${filtersGroupPath}.${index}`}
                selectedDimensionFilter={filter}
                onDelete={() => remove(index)}
              />
            </RuleBg>
            {fields.length !== index + 1 && (
              <ConditionalDivider>AND</ConditionalDivider>
            )}
          </Box>
        ))}
      </InnerContainer>
      <AddButton onClick={handleAddRule}>
        <AddIcon />
        <Typography>Add rule</Typography>
      </AddButton>
    </GroupWrapper>
  );
};
